import { render, staticRenderFns } from "./NoActivityBanner.vue?vue&type=template&id=045707dc&scoped=true&"
import script from "./NoActivityBanner.vue?vue&type=script&lang=ts&"
export * from "./NoActivityBanner.vue?vue&type=script&lang=ts&"
import style0 from "./NoActivityBanner.vue?vue&type=style&index=0&id=045707dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045707dc",
  null
  
)

export default component.exports